// @flow
/**
 * Created by Mike Chung on 2/14/18.
 */

import type {JwtReadyAction} from "../actions/profile/jwtAction";
import * as jwt from 'jsonwebtoken';

export type JwtState = {
    userId: string,
    roleIds: Array<string>,
    jwt: string
}

const INITIAL_STATE: ?JwtState = null;

export default function reducer(state: ?JwtState = INITIAL_STATE, action: JwtReadyAction) {

    switch (action.type) {
        case "profile/JWT_LOAD_SUCCESS_ACTION":
            try {

                let token = jwt.decode(action.jwt);
                let userId = token.sub;
                let roleIds = token.rids;

                return {
                    ...state,
                    userId,
                    roleIds,
                    jwt: action.jwt
                };
            } catch (e) {
                return {
                    ...state
                };
            }
        case "profile/LOGOUT_ACTION":
            return null;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/JwtReducer.js